<template>
  <v-card outlined>
    <v-card-title primary-title v-if="getModalListarVenda">
      Vendas
      <v-spacer></v-spacer>
      <v-btn icon @click="setModalListarVenda(false)" float-right>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-title>
      <v-btn
        color="primary"
        @click="$router.push({ name: 'vendaCadastro' })"
        outlined
        v-if="$helper.verificaPermissao('cadastrar-venda')"
        >Cadastrar</v-btn
      >
      <v-btn
        color="default"
        v-if="!showFiltroAvancado"
        outlined
        class="ml-2"
        @click="showFiltroAvancado = true"
      >
        Filtro<v-icon right dark> search </v-icon>
      </v-btn>
      <v-btn
        color="default"
        v-if="showFiltroAvancado"
        outlined
        class="ml-2"
        @click="showFiltroAvancado = false"
      >
        Filtro<v-icon right dark> close </v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <h3>Vendas: {{ getVendas.total }} -</h3>
      <v-pagination
        outlined
        total-visible="7"
        v-model="getVendas.current_page"
        :length="getVendas.last_page"
        @input="listarVenda({ ...dataPagina, page: $event })"
      ></v-pagination>
      <!-- <v-text-field
        outlined
        dense
        v-model="search"
        append-icon="search"
        label="Pesquisar"
        single-line
        hide-details
      >
      </v-text-field> -->
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text v-if="showFiltroAvancado">
      <v-form class="px-1">
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-select
              class="mr-2 ml-2"
              :items="getFormasPagamento"
              item-text="nome"
              item-value="id"
              v-model="dataPagina.formaPagamentoId"
              label="Forma de Pagamento:"
              outlined
              dense
              type="number"
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
              class="mr-2 ml-2"
              outlined
              dense
              place
              type="date"
              label="Período Inicial"
              v-model="dataPagina.periodo_inicial"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
              class="mr-2 ml-2"
              outlined
              dense
              place
              type="date"
              label="Período Final"
              v-model="dataPagina.periodo_final"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md12 class="mr-2 ml-2">
            <v-btn
              color="success"
              outlined
              block
              @click="dataPagina.content = 'json', pesquisar()"
              >Filtrar
            </v-btn>
          </v-flex>
          <v-flex xs12 md12 class="mr-2 ml-2 mt-2">
            <v-btn
              color="primary"
              outlined
              block
              @click="dataPagina.content = 'pdf', imprimir()"
              >Imprimir
            </v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-card-text>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th align="center">Cód</th>
              <th width="30%">Cliente</th>
              <th>status</th>
              <th>Total</th>
              <th>Data</th>
              <th>Nº NF-e</th>
              <!-- <th>Nº NF-e</th> -->
              <th>Nº NFC-e</th>
              <!-- <th>Nº NFC-e</th> -->
              <th>Exibir</th>
            </tr>
            <tr>
              <th algin="center">
                <v-text-field
                  v-model="dataPagina.id"
                  outlined
                  dense
                  class="mt-2"
                  @input="debouncedPesquisar()"
                  type="number"
                ></v-text-field>
              </th>
              <th>
                <v-text-field
                  v-model="dataPagina.cliente"
                  outlined
                  dense
                  class="mt-2"
                  @input="debouncedPesquisar()"
                ></v-text-field>
              </th>
              <th>
                <v-select
                  :items="['', 'Finalizado', 'Excluído']"
                  v-model="dataPagina.status"
                  class="mt-2"
                  outlined
                  dense
                  @input="debouncedPesquisar()"
                ></v-select>
              </th>
              <th></th>
              <th>
                <v-text-field
                  v-model="dataPagina.data"
                  outlined
                  dense
                  class="mt-2"
                  type="date"
                  @input="debouncedPesquisar()"
                ></v-text-field>
              </th>
              <!-- <th>
                <v-select
                  :items="['', 'APROVADO', 'CANCELADO', 'REJEITADO']"
                  v-model="dataPagina.estadoNfe"
                  class="mt-2"
                  outlined
                  dense
                  @input="debouncedPesquisar()"
                ></v-select>
              </th> -->
              <th>
                <v-text-field
                  v-model="dataPagina.numeroNfe"
                  outlined
                  dense
                  class="mt-2"
                  @input="debouncedPesquisar()"
                ></v-text-field>
              </th>
              <!-- <th>
                <v-select
                  :items="['', 'APROVADO', 'CANCELADO', 'REJEITADO']"
                  v-model="dataPagina.estadoNfce"
                  class="mt-2"
                  outlined
                  dense
                  @input="debouncedPesquisar()"
                ></v-select>
              </th> -->
              <th>
                <v-text-field
                  v-model="dataPagina.numeroNfce"
                  outlined
                  dense
                  class="mt-2"
                  @input="debouncedPesquisar()"
                ></v-text-field>
              </th>
              <th>
                <v-select
                  outlined
                  dense
                  :items="resultadosPorPagina"
                  item-value="value"
                  item-text="label"
                  v-model="dataPagina.limit"
                  @change="listarVenda({ ...dataPagina })"
                  class="mt-2"
                ></v-select>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="v in getVendas.data" :key="v.id">
              <td align="center">{{ v.id }}</td>
              <td width="30%">{{ v.cliente ? v.cliente.nome : "" }}</td>
              <td>{{ v.status }}</td>
              <td>{{ $helper.formatReal(parseFloat(v.total)) }}</td>
              <td>{{ $helper.formatDateTime(v.created_at) }}</td>
              <!-- <td>{{ v.estado_nfe }}</td> -->
              <td algin="center">{{ v.numero_nfe }}</td>
              <!-- <td>{{ v.estado_nfce }}</td> -->
              <td algin="center">{{ v.numero_nfce }}</td>
              <td>
                <TooltipButton
                  @click.native="visualizarVenda(v)"
                  classButton="ml-2"
                  subtitle="Visualizar"
                  icon="search"
                  color="primary"
                  v-if="$helper.verificaPermissao('visualizar-venda')"
                />
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <h3>Vendas: {{ getVendas.total }} -</h3>
      <v-pagination
        outlined
        total-visible="7"
        v-model="getVendas.current_page"
        :length="getVendas.last_page"
        @input="listarVenda({ ...dataPagina, page: $event })"
      ></v-pagination>
    </v-card-actions>

    <slot name="footer"></slot>
    <ModalVisualizar />
    <ModalTrocaVenda />
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VendaService from "@/services/VendaService";
import ModalVisualizar from "@/pages/venda/ModalVisualizar";
import ModalTrocaVenda from "@/pages/venda/ModalTrocaVenda";
import moment from "moment";
var _ = require("lodash");

export default {
  props: {
    botaoVisualizarVenda: false,
    botaoVisualizarVendaTroca: false,
  },
  components: {
    ModalVisualizar,
    ModalTrocaVenda,
  },
  data() {
    return {
      dataPagina: {
        id: "",
        cliente: "",
        status: "",
        data: "",
        estadoNfe: "",
        numeroNfe: "",
        estadoNfce: "",
        numeroNfce: "",
        limit: 20,
        page: 1,
        excluidas: true,
        formaPagamentoId: "",
        periodo_inicial: "",
        periodo_final: "",
        content: "json",
      },
      resultadosPorPagina: [
        {
          label: "10",
          value: 10,
        },
        {
          label: "20",
          value: 20,
        },
        {
          label: "30",
          value: 30,
        },
        {
          label: "40",
          value: 40,
        },
        {
          label: "50",
          value: 50,
        },
      ],
      search: "",
      
      showFiltroAvancado: false,
  
    };
  },
  computed: {
    ...mapGetters([
      "getVendas",
      "getModalListarVenda",
      "getModalVisualizarVenda",
      "getFormasPagamento",
    ]),
  },
  methods: {
    ...mapActions([
      "listarVenda",
      "visualizarVenda",
      "setModalListarVenda",
      "consultarTrocaVenda",
      "setModalTrocaVenda",
      "listarFormaPagamento",
      "gerarRelatorioVenda"
    ]),
    consultarTroca(id) {
      this.consultarTrocaVenda(id).then((res) => {
        this.setModalTrocaVenda(true);
      });
    },

    imprimir(){
      if(this.dataPagina.periodo_inicial && this.dataPagina.periodo_final){
        this.gerarRelatorioVenda({...this.dataPagina})
      }else{
        this.$store.commit('snackbarError', 'Informe o período incial e final.')
      }
    },
    pesquisar() {
      this.dataPagina.limit=20
      this.listarVenda(this.dataPagina);
    },
  },
  created() {
    this.listarVenda(this.dataPagina);
    this.listarFormaPagamento();
    this.debouncedPesquisar = _.debounce(this.pesquisar, 300);
  },
};
</script>
